export const appConstants = {
    ageListUrl: `/GeographicTrends/PopulateAgeList`,
    monthLabels: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    mapPerCapitaDesc: 'Rate of medical and pharmacy claims (per 100,000 members of the population) for vaccinations for the indicated disease.<br/> This data can help compare rates of vaccination in states with different population sizes.',
    mapDefaultDesc: 'Indicates change in medical and pharmacy vaccination claims (increase or decrease) in comparison to 2019.',
    influenza: 100,
    national: 0,
    timePeriod: 2025,
    timePeriod2: 2024, // This should be previous year minus 1 year
    ageGroup: 1,
    medicaidTotal: 2,
    medicaidManagedCare: 7,
    medicaidFFS: 8,
    tooltipByAge: `Total number of medical and pharmacy claims for vaccinations for the indicated disease in the U.S., separated by age (as indicated in claim data). Data is currently available for adults only (age 19+).`,
    tooltipByGender: `Total number of medical and pharmacy claims for vaccinations for the indicated disease in the U.S., separated by gender (as indicated in claim data).`,
    tooltipByEthnicity: `Total number of medical and pharmacy claims for vaccinations for the indicated disease in the U.S., separated by ethnicity (as indicated by claim data).`,
    tooltipTotalVaccinated: `Total number of medical and pharmacy claims for vaccinations for the indicated disease in the U.S.`,
    tooltipGapAnalysis: 'Increase or decrease in claims of recommended adult vaccines from 2019 to year selected.'    
}